<script setup>
const props = defineProps({
  pref: {
    type: String,
    required: true
  }
})
const config = useRuntimeConfig()
const { data: thumbnailList } = await useFetch(
  computed(() => `${config.public.siteDataDomain}/site/onebox/livecam/${props.pref}/map/point_list.json`)
)
</script>

<template>
  <div class="prefMap">
    <CommonPageTitle :title="`${getPrefectureName(pref)}のライブカメラ`" />
    <figure class="image">
      <img
        :src="`https://gvs.weathernews.jp/onebox/img/livecam/map/${pref}.webp`"
        alt=""
      >
      <template v-if="pref === 'tokyo'">
        <NuxtLink
          v-for="(item, key) in thumbnailList.list "
          :key="key"
          :to="`${getAreaPath(item.pref.toLowerCase())}${item.camid}/`"
          class="map__link"
          :data-area-tokyo="key"
        >
          <p>{{ item.name }}</p>
          <figure>
            <img
              :src="item.image"
              alt=""
            >
          </figure>
        </NuxtLink>
      </template>
      <template v-if="pref === 'osaka'">
        <NuxtLink
          v-for="(item, key) in thumbnailList.list "
          :key="key"
          :to="`${getAreaPath(item.pref.toLowerCase())}${item.camid}/`"
          class="map__link"
          :data-area-osaka="key"
        >
          <p>{{ item.name }}</p>
          <figure>
            <img
              :src="item.image"
              alt=""
            >
          </figure>
        </NuxtLink>
      </template>
      <template v-if="pref === 'aichi'">
        <NuxtLink
          v-for="(item, key) in thumbnailList.list "
          :key="key"
          :to="`${getAreaPath(item.pref.toLowerCase())}${item.camid}/`"
          class="map__link"
          :data-area-aichi="key"
        >
          <p>{{ item.name }}</p>
          <figure>
            <img
              :src="item.image"
              alt=""
            >
          </figure>
        </NuxtLink>
      </template>
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.prefMap {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .image {
    position: relative;
    width: 100%;
    aspect-ratio: 28 / 23;
    img {
      width: 100%;
    }
  }
  .map__link {
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: max(5px, 1.33vw);
    padding: max(4px, 1.07vw) max(2px, 0.53vw) max(2px, 0.53vw);
    border-radius: max(2px, 0.53vw);
    border: 1px solid #DFE4F0;
    background-color: #FFF;
    box-shadow: 0 max(4px, 1.07vw) max(4px, 1.07vw) 0 rgb(0 0 0 / .25);
    max-width: 94px;
    p {
      color: #1F59BA;
      font-size: max(10px, 2vw);
      max-width: max(40px, 10vw);
      font-weight: 600;
      line-height: 1em;
      text-decoration: underline;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }
    figure {
      width: max(40px, 10vw);
      height: max(40px, 10vw);
      border-radius: max(3px, 0.8vw);
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: bottom;
      }
    }
    &[data-area-tokyo="0"] {
      top: 40%;
      left: 85%;
    }
    &[data-area-tokyo="1"] {
      top: 45%;
      left: 60%;
    }
    &[data-area-tokyo="2"] {
      top: 40%;
      left: 40%;
    }
    &[data-area-tokyo="3"] {
      top: 65%;
      left: 75%;
    }
    &[data-area-tokyo="4"] {
      top: 20%;
      left: 70%;
    }
    &[data-area-tokyo="5"] {
      top: 20%;
      left: 20%;
    }
    &[data-area-tokyo="6"] {
      top: 60%;
      left: 23%;
    }
    &[data-area-aichi="0"] {
      top: 32%;
      left: 15%;
    }
    &[data-area-aichi="1"] {
      top: 7%;
      left: 27%;
    }
    &[data-area-aichi="2"] {
      top: 60%;
      left: 20%;
    }
    &[data-area-aichi="3"] {
      top: 25%;
      left: 60%;
    }
    &[data-area-aichi="4"] {
      top: 60%;
      left: 43%;
    }
    &[data-area-aichi="5"] {
      top: 33%;
      left: 39%;
    }
    &[data-area-osaka="0"] {
      top: 18%;
      left: 52%;
    }
    &[data-area-osaka="1"] {
      top: 50%;
      left: 38%;
    }
    &[data-area-osaka="2"] {
      top: 62%;
      left: 55%;
    }
    &[data-area-osaka="3"] {
      top: 25%;
      left: 35%;
    }
    &[data-area-osaka="4"] {
      top: 35%;
      left: 68%;
    }
    &[data-area-osaka="5"] {
      top: 75%;
      left: 35%;
    }
  }
  @media (any-hover: hover) {
    .map__link {
      transition: .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
}
@media screen and (min-width: 830px) {
  .prefMap {
    .map__link {
      gap: min(0.47vw, 5px);
      padding: min(0.75vw, 8px) min(0.47vw, 5px) min(0.47vw, 5px);
      border-radius: min(0.56vw, 6px);
      box-shadow: 0 min(0.37vw, 4px) min(0.37vw, 4px) 0 rgb(0 0 0 / .25);
      max-width: 92px;
      p {
        font-size: min(1.12vw, 12px);
        max-width: min(8.41vw, 80px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      figure {
        width: min(8.41vw, 80px);
        aspect-ratio: 4 / 3;
        height: auto;
        border-radius: min(0.56vw, 6px);
      }
      &[data-area-tokyo="0"] {
        top: 40%;
        left: 82%;
      }
      &[data-area-tokyo="1"] {
        top: 45%;
        left: 60%;
      }
      &[data-area-tokyo="2"] {
        top: 35%;
        left: 40%;
      }
      &[data-area-tokyo="3"] {
        top: 65%;
        left: 75%;
      }
      &[data-area-tokyo="4"] {
        top: 18%;
        left: 70%;
      }
      &[data-area-tokyo="5"] {
        top: 20%;
        left: 20%;
      }
      &[data-area-tokyo="6"] {
        top: 58%;
        left: 23%;
      }
      &[data-area-aichi="0"] {
        top: 30%;
        left: 15%;
      }
      &[data-area-aichi="1"] {
        top: 8%;
        left: 27%;
      }
      &[data-area-aichi="2"] {
        top: 55%;
        left: 20%;
      }
      &[data-area-aichi="3"] {
        top: 25%;
        left: 60%;
      }
      &[data-area-aichi="4"] {
        top: 55%;
        left: 43%;
      }
      &[data-area-aichi="5"] {
        top: 30%;
        left: 39%;
      }
      &[data-area-osaka="0"] {
        top: 15%;
        left: 52%;
      }
      &[data-area-osaka="1"] {
        top: 50%;
        left: 38%;
      }
      &[data-area-osaka="2"] {
        top: 58%;
        left: 57%;
      }
      &[data-area-osaka="3"] {
        top: 28%;
        left: 33%;
      }
      &[data-area-osaka="4"] {
        top: 37%;
        left: 65%;
      }
      &[data-area-osaka="5"] {
        top: 75%;
        left: 35%;
      }
    }
  }
}
</style>
